/**
 * Flows module — route table.
 *
 * Each entry is wrapped in `<ProtectedRoute>` + `<RequireFeature flag="modules.flows">`
 * by the central Router. This file is the single source of truth for the
 * flows module's URL space — to add a page, lazy-import it and append.
 */
import React from 'react';

export interface FlowsRouteConfig {
  path: string;
  component: React.LazyExoticComponent<React.ComponentType>;
  requireRole?: 'super_admin' | 'group_admin' | 'admin' | 'user';
}

export const flowsRoutes: FlowsRouteConfig[] = [
  {
    path: '/flows',
    component: React.lazy(() => import('./pages/FlowsDashboardPage')),
  },
  {
    path: '/flows/course/:courseId',
    component: React.lazy(() => import('./pages/CoursePage')),
  },
  {
    path: '/flows/course/:courseId/lesson/:lessonId',
    component: React.lazy(() => import('./pages/LessonPage')),
  },
  {
    path: '/flows/flow/:flowId',
    component: React.lazy(() => import('./pages/FlowPlayerPage')),
  },
  {
    path: '/flows/teacher',
    component: React.lazy(() => import('./pages/TeacherDashboardPage')),
    requireRole: 'admin',
  },
  {
    path: '/flows/teacher/course/:courseId/edit',
    component: React.lazy(() => import('./pages/CourseEditorPage')),
    requireRole: 'admin',
  },
  {
    path: '/flows/teacher/student/:userId',
    component: React.lazy(() => import('./pages/StudentProgressPage')),
    requireRole: 'admin',
  },
];
